import { RoleType } from '@ace-clublabs/common-membership-api-types';
import { Button, Icon } from '@ace-clublabs/shared-component-library';
import { RoleTypeRadioLabel } from './RoleTypeRadioLabel';
import { IMemberDetails } from '../../state/model';

export interface IRoleTypeRadioProps {
  role: IMemberDetails['prospectiveMemberRules']['memberRoles'][0];
  selectedRole: RoleType | null;
  cost: number;
  inRenewal: boolean;
  selectRoleType: (roleType: RoleType) => void;
  disabled: boolean;
}

export const RoleTypeRadio = ({
  role,
  selectedRole,
  cost,
  inRenewal,
  selectRoleType,
  disabled,
}: IRoleTypeRadioProps) => {
  const selected = selectedRole === role.roleType;

  return (
    <Button
      id={`${role.roleType}-radio`}
      variant="outlined"
      label={
        <RoleTypeRadioLabel
          checked
          roleType={role.roleType}
          limitPerHousehold={role.maximumAllowed}
          minAge={role.minimumAge}
          maxAge={role.maximumAge}
          cost={cost}
          inRenewal={inRenewal}
          disabled={disabled}
        />
      }
      onClick={() => selectRoleType(role.roleType)}
      disabled={disabled}
      sx={{
        borderColor: selected ? '#0C72DF !important' : '#D0D0D0 !important',
        borderWidth: selected ? '2px !important' : '1px !important',
        border: disabled ? 'none !important' : '',
        minWidth: '100%',
        height: 'fit-content',
        background: disabled ? '#EBEBED' : '',
        justifyContent: 'flex-start',
        gap: '0.75rem',
        padding: '0.625rem 0.625rem 0.625rem 0.75rem',
        '& .MuiButton-startIcon': {
          display: 'flex !important',
          alignSelf: 'self-start !important',
        },
        '& .css-gcc2o7-MuiButton-startIcon': {
          margin: '0',
        },
      }}
      startIcon={
        <Icon
          className="selected-member-check-icon"
          iconName={selected ? 'circle-dot-regular' : 'circle-regular'}
          sx={{
            fontSize: '1.5rem !important',
          }}
        />
      }
    />
  );
};
